// extracted by mini-css-extract-plugin
module.exports = {"module":"ErrorPage_module__dn8pF"};